import { render, staticRenderFns } from "./ServiceCard.vue?vue&type=template&id=06c363bc&scoped=true"
import script from "./ServiceCard.vue?vue&type=script&lang=ts"
export * from "./ServiceCard.vue?vue&type=script&lang=ts"
import style0 from "./ServiceCard.vue?vue&type=style&index=0&id=06c363bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c363bc",
  null
  
)

export default component.exports